/**
 * map style
 * @author zhb
 */

import 'ol/ol.css';
import Map from 'ol/Map';
import View from 'ol/View';
import { Draw, Modify, Snap } from 'ol/interaction';
import { Tile as TileLayer, Vector as VectorLayer } from 'ol/layer';
// import { OSM, Vector as VectorSource } from 'ol/source';
import { Circle as CircleStyle, Fill, Stroke, Style, Icon } from 'ol/style';

import sysIconConf from './sysIconsConf'

let mapStyle = {};
//地图上船舶的普通样式
mapStyle.normalShipStyle = new Style({
    image: new Icon({
        anchor: [0.5, 0.5],
        src: sysIconConf.SHIPICON_N,
        rotation: 0
    })
});

mapStyle.heightShipStyle = new Style({
    image: new Icon({
        anchor: [0.5, 0.5],
        src: sysIconConf.SHIPICON_V,
        rotation: 0
    })
});

//地图上港口的普通样式
mapStyle.normalShiportStyle = new Style({
    image: new Icon({
        anchor: [0.5, 0.5],
        src: sysIconConf.SHIPORTICON_N,
        rotation: 0
    })
});

mapStyle.heightShiportStyle = new Style({
    image: new Icon({
        anchor: [0.5, 0.5],
        src: sysIconConf.SHIPORTICON_V,
        rotation: 0
    })
});

///船舶轨迹样式
mapStyle.trialStyle = new Style({
    stroke: new Stroke({
        color: 'red',
        width: 2,
        rotation: 0
    })
});

//起点的普通样式
mapStyle.startStyle = new Style({
    image: new Icon({
        anchor: [0.5, 1],
        src: sysIconConf.START,
        rotation: 0
    })
});

//起点的普通样式
mapStyle.endStyle = new Style({
    image: new Icon({
        anchor: [0.5, 1],
        src: sysIconConf.END,
        rotation: 0
    })
});


//渔船定位的样式
mapStyle.shipPosStyle = new Style({
    image: new Icon({
        anchor: [0.5, 0.5],
        src: sysIconConf.END,
        rotation: 0
    })
});


//点击的样式
mapStyle.clickPosStyle = new Style({
    image: new Icon({
        anchor: [0.5, 1],
        src: sysIconConf.dangqianweizhi,
        rotation: 0
    })
});


//港口普通的样式
mapStyle.shiportNStyle = new Style({
    image: new CircleStyle({
        radius: 5,
        stroke: new Stroke({
            color: '#fff'
        }),
        fill: new Fill({
            color: '#3399CC'
        })
    }),
});


//港口高亮的样式
mapStyle.shiportHStyle = new Style({
    image: new CircleStyle({
        radius: 5,
        stroke: new Stroke({
            color: '#fff'
        }),
        fill: new Fill({
            color: '#f00'
        })
    }),
});




//渔船途径点普通的样式
mapStyle.shipPosNStyle = new Style({
    image: new CircleStyle({
        radius: 5,
        stroke: new Stroke({
            color: 'red',
            width: 2
        }),
        fill: new Fill({
            color: 'rgba(255,255,255,.6)'
        })
    }),
});
//focus 普通样式
mapStyle.shipPosNFStyle = new Style({
    image: new CircleStyle({
        radius: 8,
        stroke: new Stroke({
            color: 'red',
            width: 2
        }),
        fill: new Fill({
            color: 'rgba(255,255,255,.6)'
        })
    }),
});

//渔船途径点高亮的样式
mapStyle.shipPosHStyle = new Style({
    image: new CircleStyle({
        radius: 5,
        stroke: new Stroke({
            color: 'green',
            width: 2
        }),
        // fill: new Fill({
        //     color: 'green'
        // })
    }),
});
//focus 高亮样式
mapStyle.shipPosHFStyle = new Style({
    image: new CircleStyle({
        radius: 8,
        stroke: new Stroke({
            color: 'green',
            width: 2
        }),
        // fill: new Fill({
        //     color: 'green'
        // })
    }),
});


//定位的样式
mapStyle.posStyle = new Style({
    image: new Icon({
        anchor: [0.5, 0.5],
        src: sysIconConf.ADDRESS,
        rotation: 0
    })
});

export default mapStyle;


// WEBPACK FOOTER //
// ./src/store/mapStyle.js